import script from "./DropdownItemMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownItemMobile.vue?vue&type=script&setup=true&lang=js"

import "./DropdownItemMobile.vue?vue&type=style&index=0&id=0e534b29&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e534b29"]])

export default __exports__